"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
const escapesData = [{
  id: "villas",
  title: "Colombia",
  tag: "",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/caribbean_private_villa_luxury.png",
  className: "md:col-span-2 md:row-span-2 min-h-[400px] md:min-h-[600px]",
  link: "/Colombia"
}, {
  id: "yachts",
  title: "Greece",
  tag: "",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/caribbean_yacht_charter_ocean.png",
  className: "md:col-span-2 md:row-span-1 min-h-[300px]",
  link: "/Greece"
}, {
  id: "tours",
  title: "Puerto Rico",
  tag: "",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/caribbean_cultural_carnival.png",
  className: "md:col-span-1 md:row-span-1 min-h-[300px]",
  link: "/PuertoRico"
}, {
  id: "custom",
  title: "Egypt",
  tag: "",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/caribbean_custom_beach_dinner.png",
  className: "md:col-span-1 md:row-span-1 min-h-[300px]",
  link: "/Egypt"
}];
export default function IslandRhythmsCuratedEscapes() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="150833" id="legendary-destinations" className="bg-background py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={cn("flex flex-col md:flex-row md:items-end justify-between gap-8 mb-12 md:mb-16 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-foreground/90 leading-tight mb-4">
              Legendary & <br className="hidden md:block" />
              <span className="text-secondary">Curated Destinations</span>
            </h2>
            <p className="text-lg text-muted-foreground/80 font-sans">
              Don’t just travel, PS Travel. We believe in leaving the world better than we found it, through curated experiences that connect you to the heart of local culture.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6 auto-rows-fr">
          {escapesData.map((item, i) => <div key={item.id} data-index={i} className={cn("group relative h-full w-full transition-all duration-1000 ease-out delay-[calc(100ms*var(--index))]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12", item.className)} style={{
          "--index": i
        } as React.CSSProperties}>
              <Link to={item.link} className="block w-full h-full outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-sm">
                <Card className="relative w-full h-full overflow-hidden border-0 rounded-sm bg-transparent p-0 m-0 ring-inset transition-all duration-500 group-hover:ring-1 group-hover:ring-secondary">
                  {}
                  <img src={item.image} alt={item.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110" />
                  
                  {}
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/95 via-primary/40 to-transparent transition-opacity duration-500 group-hover:opacity-100" />

                  {}
                  <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-between z-10">
                    {}
                    <div className="overflow-hidden pt-2 pl-2 -ml-2 -mt-2">
                      <Badge variant="secondary" className="transform -translate-x-full opacity-0 transition-all duration-500 ease-out group-hover:translate-x-0 group-hover:opacity-100 shadow-lg rounded-sm">
                        {item.tag}
                      </Badge>
                    </div>

                    {}
                    <div className="flex items-center justify-between mt-auto transform transition-transform duration-500 group-hover:translate-y-[-8px]">
                      <h3 className="text-foreground font-default font-bold uppercase tracking-widest text-xl md:text-2xl lg:text-3xl leading-none">
                        {item.title}
                      </h3>
                      <div className="w-10 h-10 rounded-sm bg-secondary/20 backdrop-blur-sm flex items-center justify-center opacity-0 -translate-x-4 transition-all duration-500 group-hover:opacity-100 group-hover:translate-x-0 border border-secondary/30">
                        <ArrowRight className="w-5 h-5 text-secondary" />
                      </div>
                    </div>
                  </div>
                </Card>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}